import Nullstack from 'nullstack';
export default function IconTopologyStarRing3({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-topology-star-ring-3",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M6 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M14 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M15 7l-2 3"
  }), "   ", Nullstack.element("path", {
    d: "M9 7l2 3"
  }), "   ", Nullstack.element("path", {
    d: "M11 14l-2 3"
  }), "   ", Nullstack.element("path", {
    d: "M13 14l2 3"
  }), "   ", Nullstack.element("path", {
    d: "M10 5h4"
  }), "   ", Nullstack.element("path", {
    d: "M10 19h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 17l2 -3"
  }), "   ", Nullstack.element("path", {
    d: "M19 10l-2 -3"
  }), "   ", Nullstack.element("path", {
    d: "M7 7l-2 3"
  }), "   ", Nullstack.element("path", {
    d: "M5 14l2 3"
  }), " ");
}